class ContratoEstoqueService
  @$inject = ['genericServiceHelper']

  constructor: (serviceHelper) ->
    serviceHelper(
      url: '/eficiencia-fiscal/contrato-estoque/'
      screenId: '#eficiencia-fiscal'
      service: this
    )

angular.module('eficienciaFiscalModule').service('contratoEstoqueService', ContratoEstoqueService)
